import {
  WrenchIcon,
  VihicleIcon,
  UsersIcon,
  DocumentIcon,
  WarningIcon,
  PartsIcon,
  ExpenseIcon,
  NotificationIcon,
} from "Assets";
import { INotification } from "Shared/Types/notifications";

export const notificationPresentation = (
  notification: INotification,
  route?: string,
) => {
  if (route?.startsWith("/reminders/services"))
    return {
      Icon: WrenchIcon,
      label: "Service reminder",
      action: "Open service reminder",
      tone: "service",
    };
  if (route?.startsWith("/reminders/vehicles"))
    return {
      Icon: VihicleIcon,
      label: "Vehicle renewal",
      action: "Open vehicle renewal",
      tone: "vehicle",
    };
  if (route?.startsWith("/reminders/contacts"))
    return {
      Icon: UsersIcon,
      label: "Contact renewal",
      action: "Open contact renewal",
      tone: "contact",
    };
  const labels: Record<string, string> = {
    vehicles: "Vehicles",
    contacts: "Contacts",
    issues: "Issues",
    parts: "Parts",
    purchase_order: "Purchase orders",
    service_entry: "Service history",
    vendors: "Vendors",
    work_orders: "Work orders",
    inspection: "Inspections",
    reminders: "Reminders",
    fuel: "Fuel",
    reports: "Reports",
    inventory: "Inventory",
    billing: "Billing",
  };
  const icons: Record<string, typeof WrenchIcon> = {
    vehicles: VihicleIcon,
    contacts: UsersIcon,
    issues: WarningIcon,
    work_orders: DocumentIcon,
    inspection: DocumentIcon,
    service_entry: WrenchIcon,
    parts: PartsIcon,
    inventory: PartsIcon,
    billing: ExpenseIcon,
  };
  const label = labels[notification.app_name] || "Fleet update";
  return {
    Icon: icons[notification.app_name] || NotificationIcon,
    label,
    action: `Open ${label.toLowerCase()}`,
    tone: "general",
  };
};
